import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


function Process(){
    return(
        <Row className="spacingMin differentColor"  style={{marginLeft: "0px", marginRight: "0px" }} >
            
            <div style={{maxWidth: "1140px", marginLeft: "auto", marginRight: "auto", display: "flex", flexWrap: "wrap"}}>
            <Col md={12}>
                <div className="titleProcess">The Process</div>
            </Col>
           
            <Col md={4} data-aos={"fade-up"} className="noPadMob">
                <div className="itemBox" >
                    <img src="https://media3.giphy.com/media/jTYNW8pnbYclhRNFGJ/giphy.gif"  className="processImages" />
                    <div class="processTitle">
                        Concept & Design
                    </div>
                    <div className="processText" >
                        We first start by understanding your needs and the final goal. This step includes a free, fully interactive design
                        and an affordable pricing structure.
                    </div>

                </div>
            </Col>
            <Col md={4} data-aos={"fade-up"} className="noPadMob">
                <div className="itemBox">
                    <img src="https://media2.giphy.com/media/Xewd1FCKhS5oHmtSJh/giphy.gif"  className="processImages" />
                    <div class="processTitle">
                        Build & Testing
                    </div>
                    <div className="processText" >
                        Then we design it and give you a test environment to take a look at your app. This step includes a fully working version
                        of your app (Not a prototype like Concept & Design).
                    </div>
                </div>
            </Col>
            <Col md={4} data-aos={"fade-up"} className="noPadMob">
                <div className="itemBox">
                    <img src="https://media0.giphy.com/media/fwEWXWSaYNZFWeyg1C/giphy.gif" className="processImages" />
                    <div class="processTitle">
                        Deploy
                    </div>
                    <div className="processText" >
                        If you feel it's ready, we then proceed to launch it, and do revisions. This step includes all maintenance, any immediate iterations and 
                        continuous debugging.
                    </div>
                </div>
            </Col>
            </div>
        </Row>
    )
}


export default Process;